import { DARK_SURFACE, deriveBrandTheme, pickBrandSeed } from '@/lib/brandTheme';
import { COPY } from '@/lib/copyTokens';

/**
 * Shows the derived dashboard accent on the two surfaces it actually paints.
 * Invalid or unsafe brand colors fail open and render no preview.
 */
export function BrandAccentPreview({
  primary,
  secondary,
}: {
  primary: string | undefined;
  secondary: string | undefined;
}) {
  const seed = pickBrandSeed({ primary, secondary });
  const theme = seed ? deriveBrandTheme(seed) : null;
  if (!theme) return null;

  return (
    <div data-testid="dashboard-accent-preview" className="mt-4">
      <span className="text-xs font-medium text-ink-3">{COPY.dashboardAccent}</span>
      <div className="mt-1 flex items-center gap-2">
        <div
          data-testid="accent-ground-light"
          className="flex items-center gap-2 rounded-md bg-warm-bg p-2"
        >
          <div
            data-testid="accent-swatch-light"
            className="h-6 w-6 rounded border border-warm-border"
            style={{ backgroundColor: theme.accent }}
          />
        </div>
        <div
          data-testid="accent-ground-dark"
          className="flex items-center gap-2 rounded-md p-2"
          style={{ backgroundColor: DARK_SURFACE }}
        >
          <div
            data-testid="accent-swatch-dark"
            className="h-6 w-6 rounded"
            style={{ backgroundColor: theme.darkAccent }}
          />
        </div>
      </div>
    </div>
  );
}
